<template>
  <p class="wrap"><span>{{ i18n.lbl_time_to_refund() }}</span>&nbsp;&nbsp;<span class="wait-text">{{ timerDisplay }}</span></p>
</template>
  
  <script>
  import { i18n } from '@js/i18n'
  export default {
    name: 'Timer',
    props: {
      timer: { type: Object, required: true }
    },
    emits: ['action'],
    data () {
      return {
        i18n,
        localTimer: {
          minutes: 0,
          seconds: 0,
          hours: 0
        },
        interval: null
      }
    },
    created () {
      this.localTimer = {...this.timer}
      this.startTimer()
    },
    beforeUnmount () {
      this.stopTimer()
    },
    computed: {
      timerDisplay () {
        return `${this.formatTime(this.hours)}:${this.formatTime(this.minutes)}:${this.formatTime(this.seconds)}`
      },
      minutes () {
        return this.localTimer.minutes
      },
      hours () {
        return this.localTimer.hours
      },
      seconds () {
        return this.localTimer.seconds
      }
    },
    methods: {
      formatTime (time) {
        return time < 10 ? `0${time}` : time
      },
      startTimer () {
        this.interval = setInterval(() => {
          if (this.localTimer.hours === 0 && this.localTimer.minutes === 0 && this.localTimer.seconds === 0) {
            this.stopTimer()
            this.$emit('action')
          } else {
            if (this.localTimer.seconds === 0 && this.localTimer.minutes !== 0) {
              this.localTimer.minutes -= 1
              this.localTimer.seconds = 59
            } else if (this.localTimer.minutes === 0 && this.localTimer.hours !== 0 && this.localTimer.seconds === 0) {
              this.localTimer.hours -= 1
              this.localTimer.seconds = 59
              this.localTimer.minutes = 59
            } else {
              this.localTimer.seconds -= 1
            }
          }
        }, 1000)
      },
      stopTimer () {
        clearInterval(this.interval)
        this.localTimer = {
          minutes: 0,
          seconds: 0,
          hours: 0
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .wrap {
    max-width: 600px;
    font-size: 18px;
  }
  .wait-text {
    font-weight: bold;
    display: inline-block;
  }
  </style>


// WEBPACK FOOTER //
// src/vue/app/timer/RefundTimer.vue